import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import axios from 'axios';
import { ArrowLeftIcon, UserCircleIcon } from '@heroicons/react/24/outline';
import LoadingSpinner from '../../components/LoadingSpinner';

const CustomerDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCustomer();
  }, [id]);

  const fetchCustomer = async () => {
    try {
      const response = await axios.get(`http://localhost/saininewsite/backend/get_customer.php?id=${id}`);
      setCustomer(response.data.customer);
    } catch (error) {
      console.error('Error fetching customer:', error);
      alert('Customer not found');
      navigate('/customers/view');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <LoadingSpinner text="Loading customer details..." />;
  }

  if (!customer) {
    return <div>Customer not found</div>;
  }

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <div className="flex items-center space-x-4">
        <button
          onClick={() => navigate('/customers/view')}
          className="btn-secondary"
        >
          <ArrowLeftIcon className="h-5 w-5 mr-2" />
          Back to Customers
        </button>
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
          Customer Details
        </h1>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="card p-6"
      >
        <div className="flex items-start space-x-6">
          <div className="flex-shrink-0">
            {customer.profile_image ? (
              <img
                src={customer.profile_image}
                alt={customer.name}
                className="h-32 w-32 rounded-full object-cover"
              />
            ) : (
              <UserCircleIcon className="h-32 w-32 text-gray-400" />
            )}
          </div>
          
          <div className="flex-1 space-y-4">
            <div>
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
                {customer.name}
              </h2>
              <p className="text-gray-600 dark:text-gray-400">
                Customer ID: {customer.id}
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Mobile Number
                </label>
                <p className="text-gray-900 dark:text-white">{customer.mobile}</p>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Email
                </label>
                <p className="text-gray-900 dark:text-white">{customer.email || 'Not provided'}</p>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Father's Name
                </label>
                <p className="text-gray-900 dark:text-white">{customer.father_name || 'Not provided'}</p>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Mother's Name
                </label>
                <p className="text-gray-900 dark:text-white">{customer.mother_name || 'Not provided'}</p>
              </div>

              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Address
                </label>
                <p className="text-gray-900 dark:text-white">{customer.address || 'Not provided'}</p>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Created Date
                </label>
                <p className="text-gray-900 dark:text-white">
                  {new Date(customer.created_at).toLocaleString()}
                </p>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Last Updated
                </label>
                <p className="text-gray-900 dark:text-white">
                  {new Date(customer.updated_at).toLocaleString()}
                </p>
              </div>
            </div>

            {customer.documents && customer.documents.length > 0 && (
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Documents
                </label>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                  {customer.documents.map((doc, index) => (
                    <div key={index} className="border border-gray-200 dark:border-gray-700 rounded-lg p-3">
                      <p className="text-xs text-gray-600 dark:text-gray-400 text-center truncate">
                        {doc.original_name}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default CustomerDetail;
